import React from 'react'
import './edit-teacher-availability-popup.css'
import { baseUrl } from '../../assets/Animations'
import Axios from 'axios'
import AvailabilityByDayPopup from '../../TeacherPortal2021/AvailabilityByDayPopup/AvailabilityByDayPopup'
import { format, parse } from 'date-fns'

const myToken = localStorage.getItem('token')
const myHeader = {
    headers: { Authorization: `Bearer ${myToken}` }
}

const EditTeacherAvailabilityPopup = (props) => {
    const [openDayPopup, setOpenDayPopup] = React.useState('')
    const allDays = [{ day: 'Monday', abbr: 'Mon'},{ day: 'Tuesday', abbr: 'Tue'},{ day: 'Wednesday', abbr: 'Wed'},{ day: 'Thursday', abbr: 'Thu'},{ day: 'Friday', abbr: 'Fri'},{ day: 'Saturday', abbr: 'Sat'},{ day: 'Sunday', abbr: 'Sun'}]

    const updateAndCloseAvailabilityModal = (wholeAvail) => {
        Axios.put(`${baseUrl}/teacherschedule`, {
            Email: props.email,
            AvailabilityDetails: wholeAvail
        }, myHeader)
        .then((res) => {
            props.setTeachAvail(res.data.AvailabilityDetails)
            //props.setAvailabilityByDay('')
            setOpenDayPopup('')
        })
        .catch((err) => {
            console.log(err)
        })
    }


    return(
        <div className='edit-teacher-availability-popup__wrapper'>
            <div className='edit-teacher-availability-popup'>
                <div className='edit-teacher-availability-popup__name'>{props.teacherName.split(' ')[0]}'s Availability</div>
                {openDayPopup !== '' && <AvailabilityByDayPopup availability={props.teacherAvail} dayToEdit={openDayPopup} setAvailabilityByDay={setOpenDayPopup} updateAndCloseAvailabilityModal={updateAndCloseAvailabilityModal} setOpenDayPopup={setOpenDayPopup} name={props.teacherName.split(' ')[0]} />}
                {allDays.map((day, index) => 
                    <div key={index} className="new-teacher-portal__day-button" { ...props.teacherAvail[day.day].length === 0 && {style: {background: 'linear-gradient(to left, #fff, rgb(255, 150, 150))'}}} onClick={() => setOpenDayPopup(day.day)}>
                        <div className="new-teacher-portal__day-square">{day.abbr}</div>
                        <div className="new-teacher-portal__label-area">
                            {props.teacherAvail[day.day].map((timeInterval, i) => 
                                <div key={i} {...props.teacherAvail[day.day].length > 2 ? {style: {fontSize: '10px', display: "inline-block"}} : {style: {marginTop: "10px"}}} className="new-teacher-portal__day-button__availability">{timeInterval.start && format(parse(timeInterval.start, 'H:mm', new Date()), 'h:mm a')} - {timeInterval.end && format(parse(timeInterval.end, 'H:mm', new Date()), 'h:mm a')}</div>
                            )}
                        </div>
                        <img className="new-teacher-portal__day-button__arrow" src="./arrow-dark-blue.svg"/>
                    </div>
                )}
                <div className='new-teacher-portal__avail-close-btn-wrapper'>
                    <div className='new-teacher-portal__avail-close-btn' onClick={(() => props.setEditTeacherAvailability(false))}>Close {props.teacherName.split(' ')[0]}'s Availability</div>
                </div>
            </div>
        </div>
    )
}
export default EditTeacherAvailabilityPopup